const VARIANTS_BUTTONS = {
  DEFAULT_DESIGN: 'default_design',
  COLORED_SAME_SIZE: 'colored_same_size',
  COLORED_DIFFERENT_SIZES: 'colored_different_sizes'
};

export {VARIANTS_BUTTONS};
